import {useAdminLogin} from "@mytour/platform";
import {Loading} from "@mytour/ui/Loading";
import React, {useEffect} from "react";
import {Navigate, useLocation, useParams} from "react-router";
function useQuery() {
  const {search} = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function ModerationLoginPage() {
  const location = useLocation();
  const {invitationKey} = useParams<{invitationKey: string}>();
  const query = useQuery();
  const owner = query.get("owner");

  const {adminLogin, adminLoginError, adminLoginSuccess} = useAdminLogin();

  useEffect(() => {
    async function run() {
      if (invitationKey && owner) {
        await adminLogin({invitationKey, invitationOwner: owner});
      }
    }
    run();
  }, [invitationKey, owner, adminLogin]);

  if (adminLoginSuccess) {
    const {from} = (location.state as any) || {from: {pathname: "/", search: location.search}};
    return <Navigate to={from} replace />;
  }
  if (adminLoginError) {
    return <>{adminLoginError?.message || "Invitation failed"}</>;
  }

  return <Loading />;
}
